module.exports = __webpack_public_path__ + "img/icons8-html-5.a0657d1c.svg";